/* ==========================================================================
   Wefty Design — ürün sayfası "tek tıkla 10 adet" bloğu
   snippets/wefty-onlu-ekle.liquid tarafından kullanılır.

   Seçili varyantı Dawn'ın kendi formundan okur (`form[id^="product-form-"]`
   içindeki `input[name="id"]`). Dawn varyant değişince bu alanın value'sunu
   güncelleyip `change` olayı yayar — dinlediğimiz nokta orası. Böylece ayrı
   bir varyant durumu tutmuyoruz, tek doğru kaynak Dawn'ın formu.

   Fiyat önizlemesi TAHMİNDİR. Gerçek indirim Shopify'ın otomatik indirim
   kuralından sepette gelir; arayüzde de "sepette" diye yazar.
   ========================================================================== */

(function () {
  'use strict';

  function paraBicimlendir(kurus, kod, dil) {
    var tutar = kurus / 100;
    try {
      return new Intl.NumberFormat(dil || 'tr-TR', {
        style: 'currency',
        currency: kod || 'TRY',
        minimumFractionDigits: 2,
      }).format(tutar);
    } catch (e) {
      return tutar.toFixed(2) + ' ' + (kod || '');
    }
  }

  /* Formu ÖNCE bölüm id'sinden bulur. Sayfada başka ürün formu da olabilir
     (ör. ilgili ürünlerde hızlı ekleme açılırsa); o zaman sayfadaki ilk formu
     okumak yanlış varyantı sepete atardı. Bölüm id'si verilmemişse eski
     davranışa düşer — blok yine çalışır, sadece daha az kesin. */
  function formBul(kok) {
    var id = kok && kok.dataset.form;
    if (id) {
      var f = document.getElementById(id);
      if (f) return f;
    }
    return document.querySelector('form[id^="product-form-"]');
  }

  function varyantOku(kok) {
    var form = formBul(kok);
    if (!form) return null;
    var alan = form.querySelector('input[name="id"]');
    if (!alan || !alan.value) return null;
    return alan.value;
  }

  function Onlu(kok) {
    this.kok = kok;
    this.adet = parseInt(kok.dataset.adet, 10) || 10;
    this.yuzde = parseFloat(kok.dataset.yuzde) || 15;
    this.paraKodu = kok.dataset.para || 'TRY';
    this.dil = kok.dataset.dil || 'tr-TR';

    try {
      this.fiyatlar = JSON.parse(kok.dataset.fiyatlar || '{}');
    } catch (e) {
      this.fiyatlar = {};
    }

    this.hesapEl = kok.querySelector('[data-wf-onlu-hesap]');
    this.eskiEl = kok.querySelector('[data-wf-onlu-eski]');
    this.yeniEl = kok.querySelector('[data-wf-onlu-yeni]');
    this.dugme = kok.querySelector('[data-wf-onlu-ekle]');
    this.hataEl = kok.querySelector('[data-wf-onlu-hata]');

    var self = this;

    this.dugme.addEventListener('click', function () {
      self.ekle();
    });

    /* Dawn varyant değişimini `change` ile yayıyor; yakalayıp önizlemeyi
       tazeliyoruz. Bölüm tema editöründe yeniden yüklenirse de tazelenir. */
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'id') self.ciz();
    });
    document.addEventListener('shopify:section:load', function () {
      self.ciz();
    });

    this.ciz();
  }

  Onlu.prototype.ciz = function () {
    var vid = varyantOku(this.kok);
    var kurus = vid ? this.fiyatlar[vid] : null;

    /* Fiyat okunamazsa satır GİZLENİR — uydurma rakam basmaktansa boş kalsın. */
    if (kurus == null) {
      this.hesapEl.hidden = true;
      return;
    }

    var toplam = kurus * this.adet;
    var inen = Math.round(toplam * (1 - this.yuzde / 100));

    this.eskiEl.textContent = this.adet + ' × ' +
      paraBicimlendir(kurus, this.paraKodu, this.dil) + ' = ' +
      paraBicimlendir(toplam, this.paraKodu, this.dil);
    this.yeniEl.textContent = paraBicimlendir(inen, this.paraKodu, this.dil);
    this.hesapEl.hidden = false;
  };

  Onlu.prototype.ekle = function () {
    var self = this;
    var vid = varyantOku(this.kok);

    if (!vid) {
      this.hata('Önce bir ölçek seçin.');
      return;
    }

    var kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var eskiMetin = this.dugme.textContent;
    this.dugme.disabled = true;
    this.dugme.textContent = 'Ekleniyor…';
    this.hataEl.hidden = true;

    fetch(kok + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: self.adet }] }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || ('HTTP ' + r.status));
          return d;
        });
      })
      .then(function () {
        window.location.href = kok + 'cart';
      })
      .catch(function (e) {
        self.dugme.disabled = false;
        self.dugme.textContent = eskiMetin;
        self.hata('Sepete eklenemedi: ' + e.message);
        if (window.console) console.error('[wefty-onlu]', e);
      });
  };

  Onlu.prototype.hata = function (metin) {
    this.hataEl.textContent = metin;
    this.hataEl.hidden = false;
  };

  function baslat() {
    document.querySelectorAll('[data-wf-onlu]').forEach(function (kok) {
      if (kok.dataset.wfKuruldu) return;
      kok.dataset.wfKuruldu = '1';
      new Onlu(kok);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  document.addEventListener('shopify:section:load', baslat);
})();
